// The strip over a list or table: its search and filters, its count, and at
// the end the view's own controls (columns, show all). It keeps one height
// whether the count has loaded or not.
export default function TableBar({ end = null, className = "", children }) {
    return (
        <div
            data-table-bar=""
            className={`flex min-h-[44px] flex-wrap items-center gap-x-[12px] gap-y-[8px] border-b border-[color:var(--line-soft)] py-[7px] text-[12.5px] leading-[1.3] text-[color:var(--muted)] ${className}`}
        >
            {children}
            {end ? <div className="ml-auto flex flex-wrap items-center gap-[8px]">{end}</div> : null}
        </div>
    );
}

// "12 tokens", in the bar's quiet type with the number in ink. Holds its
// place while the count is still unknown rather than reading "0".
export function Count({ n = null, one, many = `${one}s` }) {
    if (n == null) return <span aria-hidden="true" className="inline-block h-[10px] w-[64px] rounded-[3px] bg-[color-mix(in_srgb,var(--ink)_8%,transparent)]" />;
    return (
        <span data-table-count="">
            <span className="font-medium tabular-nums text-[color:var(--ink)]">{n.toLocaleString("en-US")}</span> {n === 1 ? one : many}
        </span>
    );
}
